<template lang="pug">
    .image
        figure(v-if="cardImage", :height="height")
            img(
                v-lazy="cardImage"
                rel="noopener"
                :alt="`Cardbild - ${altText}`"
            )
</template>
<script>
export default {
	name: "CardImage",
	props: {
		cardImage: {
			type: Object,
			required: true
		},
		height: {
			type: String,
		},
		altText: {
			type: String,
		}
	}
}
</script>
<style lang="sass" scoped></style>